riot.tag2('raw', '<span></span>', '', '', function(opts) {
(function() {
  this.root.innerHTML = opts.content;

}).call(this);
});



//////////////////
// WEBPACK FOOTER
// ./src/scripts/raw.tag.slim
// module id = 49
// module chunks = 0